export default __webpack_public_path__ + "static/media/ban-mobile-image-2.5b222657.jpg";